import React, {useContext, useState, useEffect} from 'react'
import { AppContext } from '../../App';

//import Css
import './buttonEnfoqueComponent.css'



export function ButtonEnfoqueComponent({classNameButton, iconEnfoque, textButton, IconHand, ValorPopUp}) {



    const { 

        // State popUp Enfoque
        popUpOpen,
        setpopUpOpen,
        setValorPopUp

    } = useContext(AppContext);




    return(

           <button  
           className={`btn-enfoque-component btn-enfoque-${classNameButton}`} 
            onClick={() => { 
                setpopUpOpen(!popUpOpen); 
                setValorPopUp(ValorPopUp); }
            }>

                <div className="box-text-content-enfoque">
                    <img className="icon-enfoque" src={iconEnfoque}/>
                    <span className="text-button">{textButton}</span> 
                    <img className="icon-hand"  src={IconHand}/>
                </div>

           </button>

    )

}